module.exports = __webpack_public_path__ + "img/linearAlgebra_sign.e0fa1652.png";